var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorUpwordArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.81243 0.5V4.5625C5.81243 4.64538 5.77951 4.72487 5.7209 4.78347C5.6623 4.84208 5.58281 4.875 5.49993 4.875C5.41705 4.875 5.33756 4.84208 5.27896 4.78347C5.22035 4.72487 5.18743 4.64538 5.18743 4.5625V1.2543L0.721024 5.72109C0.662386 5.77973 0.582856 5.81267 0.49993 5.81267C0.417003 5.81267 0.337474 5.77973 0.278836 5.72109C0.220198 5.66246 0.187256 5.58293 0.187256 5.5C0.187256 5.41707 0.220198 5.33754 0.278836 5.27891L4.74563 0.8125H1.43743C1.35455 0.8125 1.27506 0.779576 1.21646 0.720971C1.15785 0.662366 1.12493 0.58288 1.12493 0.5C1.12493 0.41712 1.15785 0.337634 1.21646 0.279029C1.27506 0.220424 1.35455 0.1875 1.43743 0.1875L5.49993 0.1875C5.58281 0.1875 5.6623 0.220424 5.7209 0.279029C5.77951 0.337634 5.81243 0.41712 5.81243 0.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorUpwordArrow);
export default __webpack_public_path__ + "static/media/Vector_upword_arrow.1d88289bea7a85a3a998736cfd8e42ff.svg";
export { ForwardRef as ReactComponent };